<template>
  <b-overlay :show="isLoading" rounded="sm">
    <b-row>
      <b-col cols="12">
        <b-form class="w-100" @submit.prevent>
          <b-form-group :label="placeholder" label-for="language-picker">
            <v-select
              @search="handleSearch"
              id="language-picker"
              dir="rtl"
              :filterable="false"
              v-if="categoriesList"
              v-model="selectedCategory"
              :options="categoriesList"
              label="title"
              placeholder="دسته بندی را انتخاب کنید"
            >
              <template #no-options>
                هیچ دسته بندی جهت نمایش وجود ندارد
              </template>
            </v-select>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import { FaqCategoryGetAllRequest } from "@/libs/Api/FaqCategory/FaqCategoryRequests";
import vSelect from "vue-select";
import { BOverlay, BRow, BCol, BForm, BFormGroup } from "bootstrap-vue";

export default {
  emits: ["getCategory"],
  props: {
    defaultCategoryId: {
      type: [String, Number],
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "انتخاب دسته بندی سوالات متداول",
    },
  },
  data() {
    return {
      isLoading: false,
      categoriesList: null,
      searchCommand: null,
      timeout: null,
      selectedCategory: null,
    };
  },
  async mounted() {
    await this.getAllCategories();
    if (this.defaultCategoryId) {
      let selectedCat = this.categoriesList.find(
        (item) => item.id == this.defaultCategoryId
      );
      if (selectedCat) {
        this.selectedCategory = selectedCat;
      }
    }
  },
  watch: {
    selectedCategory: {
      handler(val) {
        this.$emit("getCategory", val);
      },
    },
  },
  methods: {
    handleSearch(searchValue, loadingFn) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(async () => {
        this.searchCommand = searchValue;
        loadingFn(true);
        await this.getAllCategories();
        loadingFn(false);
      }, 300);
    },
    async getAllCategories() {
      try {
        this.isLoading = true;
        let reqParams = {
          count: 0,
          pageNumber: 0,
        };
        if (this.searchCommand && this.searchCommand != "") {
          reqParams["title"] = this.searchCommand;
        }
        let _this = this;
        let faqCategoryGetAllRequest = new FaqCategoryGetAllRequest(_this);
        faqCategoryGetAllRequest.setParams(reqParams);
        await faqCategoryGetAllRequest.fetch((response) => {
          _this.categoriesList = response.items;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    vSelect,
    BOverlay,
    BRow,
    BCol,
    BForm,
    BFormGroup,
  },
};
</script>
